import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import moduleReserva from './reserva/moduleReserva'
import moduleBoleto from './boleto/moduleBoleto'
import moduleUnidade from './unidade/moduleUnidade'
import moduleLeitura from './leitura/moduleLeitura'
import moduleConta from './conta/moduleConta'
import moduleMinhaConta from './minhaconta/moduleMinhaConta'
import moduleMural from './mural/moduleMural'
import moduleOcorrencia from './ocorrencia/moduleOcorrencia'
import moduleCorrespondencia from './correspondencia/moduleCorrespondencia'
import modulePrestacaoContas from './prestacaoconta/modulePrestacaoConta'
import moduleTelefoneUtil from './telefoneutil/moduleTelefoneUtil'
import moduleAuth from './auth/moduleAuth'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    reserva: moduleReserva,
    boleto: moduleBoleto,
    unidade: moduleUnidade,
    leitura: moduleLeitura,
    conta: moduleConta,
    auth: moduleAuth,
    minhaconta: moduleMinhaConta,
    mural: moduleMural,
    livroOcorrencia: moduleOcorrencia,
    correspondencia: moduleCorrespondencia,
    prestacaocontas: modulePrestacaoContas,
    telefonesuteis: moduleTelefoneUtil,
  },
  strict: process.env.DEV,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
})
